export const REGISTER = '@register/REGISTER';
export const REGISTER_SUCCESS = '@register/REGISTER_SUCCESS';
export const REGISTER_FAIL = '@register/REGISTER_FAIL';

export const GET_EMAIL_FOR_TOKEN = '@register/GET_EMAIL_FOR_TOKEN';
export const GET_EMAIL_FOR_TOKEN_SUCCESS = '@register/GET_EMAIL_FOR_TOKEN_SUCCESS';
export const GET_EMAIL_FOR_TOKEN_FAIL = '@register/GET_EMAIL_FOR_TOKEN_FAIL';
